import axios from 'axios';

const API_ASSEMP_URL = `${process.env.REACT_APP_ASSEMP_URL}/associados-ms/api`;

const associatesService = {
    // PARTICIPANTES
    /**
     * Buscar participante por ID
     */
    getParticipanteById: async (id) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/participante/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar participante por ID:', error);
            throw error;
        }
    },
    /**
     * Buscar contatos do participante por ID
     */
    getParticipanteContatoById: async (id) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/participante/${id}/contato`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar contato do participante:', error);
            throw error;
        }
    },
    /**
     * Buscar participantes com filtros
     */
    findParticipantes: async (params) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/participante/find`, { params });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar participantes:', error);
            throw error;
        }
    },

    // DEPENDENTES
    /**
     * Buscar todos os dependentes
     */
    getAllDependentes: async () => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/dependente`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar dependentes:', error);
            throw error;
        }
    },

    /**
     * Buscar dependentes por filtro
     */
    findDependentes: async (queryString: string) => {
        try {
            console.log("🔍 URL dependentes:", `${API_ASSEMP_URL}/associado/dependente/find?${queryString}`);
            const response = await axios.get(`${API_ASSEMP_URL}/associado/dependente/find?${queryString}`);
            console.log("✅ Resposta dependentes:", response.data);
            
            // Garantir que os dependentes tenham o campo grauParentesco
            const dependentes = response.data.content.map(dep => ({
                ...dep,
                grauParentesco: dep.grauParentesco || 'Dependente' // Garantir que sempre tenha o campo
            }));
            
            return {
                ...response.data,
                content: dependentes
            };
        } catch (error) {
            console.error('Erro ao buscar dependentes:', error);
            throw error;
        }
    },

    
    /**
     * Atualizar dados de um dependente
     */
    updateDependente: async (data) => {
        try {
            const response = await axios.put(`${API_ASSEMP_URL}/associado/dependente`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar dependente:', error);
            throw error;
        }
    },
    /**
     * Cadastrar novo dependente
     */
    createDependente: async (data) => {
        try {
            const response = await axios.post(`${API_ASSEMP_URL}/associado/dependente`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar dependente:', error);
            throw error;
        }
    },
    /**
     * Atualizar parcialmente dados de um dependente
     */
    patchDependente: async (data) => {
        try {
            const response = await axios.patch(`${API_ASSEMP_URL}/associado/dependente`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar parcialmente dependente:', error);
            throw error;
        }
    },
    /**
     * Reativar cadastro de um dependente
     */
    reativaDependente: async (id) => {
        try {
            const response = await axios.put(`${API_ASSEMP_URL}/associado/dependente/${id}/reativa`);
            return response.data;
        } catch (error) {
            console.error('Erro ao reativar dependente:', error);
            throw error;
        }
    },
    /**
     * Buscar dependente por ID
     */
    getDependenteById: async (id) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/dependente/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar dependente por ID:', error);
            throw error;
        }
    },
    /**
     * Cancelar cadastro de dependente
     */
    deleteDependente: async (id) => {
        try {
            const response = await axios.delete(`${API_ASSEMP_URL}/associado/dependente/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao deletar dependente:', error);
            throw error;
        }
    },

    // ASSOCIADOS
    /**
     * Buscar todos os associados (dados reduzidos)
     */
    getAllAssociados: async (params) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado`, { params });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar associados:', error);
            throw error;
        }
    },
    /**
     * Atualizar dados de um associado
     */
    updateAssociado: async (data) => {
        try {
            const response = await axios.put(`${API_ASSEMP_URL}/associado`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar associado:', error);
            throw error;
        }
    },
    /**
     * Cadastrar novo associado
     */
    createAssociado: async (data) => {
        try {
            const response = await axios.post(`${API_ASSEMP_URL}/associado`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar associado:', error);
            throw error;
        }
    },
    /**
     * Atualizar parcialmente dados de um associado
     */
    patchAssociado: async (data) => {
        try {
            const response = await axios.patch(`${API_ASSEMP_URL}/associado`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar parcialmente associado:', error);
            throw error;
        }
    },
    /**
     * Reativar cadastro de um associado
     */
    reativaAssociado: async (id) => {
        try {
            const response = await axios.put(`${API_ASSEMP_URL}/associado/${id}/reativa`);
            return response.data;
        } catch (error) {
            console.error('Erro ao reativar associado:', error);
            throw error;
        }
    },
    /**
     * Atualizar apenas dados de contato de um associado
     */
    updateAssociadoContato: async (data) => {
        try {
            const response = await axios.put(`${API_ASSEMP_URL}/associado/contato`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar contato do associado:', error);
            throw error;
        }
    },
    /**
     * Buscar associado por ID (completo)
     */
    getAssociadoById: async (id) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar associado por ID:', error);
            throw error;
        }
    },
    /**
     * Cancelar cadastro de associado
     */
    deleteAssociado: async (id) => {
        try {
            const response = await axios.delete(`${API_ASSEMP_URL}/associado/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao deletar associado:', error);
            throw error;
        }
    },
    /**
     * Buscar associados por filtro (dados reduzidos)
     */
    findAssociados: async (queryString) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/participante/find?${queryString}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar associados:', error);
            throw error;
        }
    },
    addDependente: async (data: any) => {
        try {
            const response = await axios.post(`${API_ASSEMP_URL}/associado/dependente`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar dependente:', error);
            throw error;
        }
    },
    // HISTÓRICO
    getHistoricoByAssociado: async (id: number | string, page = 0, size = 10) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/associado/${id}/historico`, {
                params: { page, size },
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar histórico do associado:', error);
            throw error;
        }
    },
    createHistorico: async (data: { idAssociado: number; descricao: string }) => {
        try {
            const response = await axios.post(`${API_ASSEMP_URL}/associado/historico`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar histórico:', error);
            throw error;
        }
    },
    deleteHistorico: async (id: number) => {
        try {
            const response = await axios.delete(`${API_ASSEMP_URL}/associado/historico/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir histórico:', error);
            throw error;
        }
    },

    // OCORRÊNCIAS
    getOcorrenciasByFilter: async (params: {
        idAssociado?: number;
        setor?: string[];
        dataInicio?: string;
        dataFim?: string;
        page?: number;
        size?: number;
    }) => {
        const sp = new URLSearchParams();
        if (params.idAssociado !== undefined) sp.set('idAssociado', String(params.idAssociado));
        if (params.setor?.length) params.setor.forEach((s) => sp.append('setor', s));
        if (params.dataInicio) sp.set('dataInicio', params.dataInicio);
        if (params.dataFim) sp.set('dataFim', params.dataFim);
        if (params.page !== undefined) sp.set('page', String(params.page));
        if (params.size !== undefined) sp.set('size', String(params.size));
        const response = await axios.get(`${API_ASSEMP_URL}/associado/ocorrencia/find?${sp.toString()}`);
        return response.data;
    },
    getOcorrenciaById: async (id: number) => {
        const response = await axios.get(`${API_ASSEMP_URL}/associado/ocorrencia/find/${id}`);
        return response.data;
    },
    createOcorrencia: async (data: {
        idAssociado: number;
        setoresEnvolvidos: string[];
        dataHoraOcorrencia: string;
        funcionariosEnvolvidos: string;
        descricao: string;
        arquivo?: File;
    }) => {
        const form = new FormData();
        form.append('idAssociado', String(data.idAssociado));
        data.setoresEnvolvidos.forEach((s) => form.append('setoresEnvolvidos', s));
        form.append('dataHoraOcorrencia', data.dataHoraOcorrencia);
        form.append('funcionariosEnvolvidos', data.funcionariosEnvolvidos);
        form.append('descricao', data.descricao);
        if (data.arquivo) form.append('arquivo', data.arquivo);
        const response = await axios.post(`${API_ASSEMP_URL}/associado/ocorrencia`, form);
        return response.data;
    },
    updateOcorrencia: async (data: {
        idOcorrencia: number;
        setoresEnvolvidos?: string[];
        funcionariosEnvolvidos?: string;
        descricao?: string;
    }) => {
        const response = await axios.put(`${API_ASSEMP_URL}/associado/ocorrencia`, data);
        return response.data;
    },
    deleteOcorrencia: async (id: number) => {
        const response = await axios.delete(`${API_ASSEMP_URL}/associado/ocorrencia/${id}`);
        return response.data;
    },
    uploadDocumentoOcorrencia: async (idOcorrencia: number, arquivo: File) => {
        const form = new FormData();
        form.append('idOcorrencia', String(idOcorrencia));
        form.append('arquivo', arquivo);
        const response = await axios.post(`${API_ASSEMP_URL}/associado/ocorrencia/documento`, form);
        return response.data;
    },

    /**
     * Atualizar campo de observação de um associado
     */
    updateObservacao: async (data: { id: number; observacao: string }) => {
        try {
            const response = await axios.put(`${API_ASSEMP_URL}/associado/observacao`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar observação do associado:', error);
            throw error;
        }
    },
};

export default associatesService;
